module.exports = __webpack_public_path__ + "img/head_bg.6d7fb81c.jpeg";